import { render, staticRenderFns } from "./tax-rate.vue?vue&type=template&id=f9482c0e&scoped=true&"
import script from "./tax-rate.vue?vue&type=script&lang=ts&"
export * from "./tax-rate.vue?vue&type=script&lang=ts&"
import style0 from "./tax-rate.vue?vue&type=style&index=0&id=f9482c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9482c0e",
  null
  
)

export default component.exports